import React, {useEffect, useRef, useState} from 'react';

/**
 * Defers mounting its children until the container scrolls near the viewport.
 * The wrapper renders immediately, so give it the chart's height (className/style)
 * to reserve layout and avoid scroll jumps.
 */
const LazyMount = ({
  children,
  className,
  style,
  rootMargin = '200px',
  fallback = null,
}) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (shown) return undefined;
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setShown(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      entries => {
        if (entries.some(e => e.isIntersecting)) {
          setShown(true);
          io.disconnect();
        }
      },
      {rootMargin},
    );
    io.observe(el);
    return () => io.disconnect();
  }, [shown, rootMargin]);

  return (
    <div ref={ref} className={className} style={style}>
      {shown ? children : fallback}
    </div>
  );
};

export default LazyMount;
